(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion-panel-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('premium-accordion-panel')) {
    class PremiumAccordionPanel extends HTMLElement {
      constructor() {
        super();

        this.card = null;
        this.trigger = null;
        this.content = null;
        this.contentInner = null;

        this.isAnimating = false;
        this.isOpen = false;

        this.animationDuration = 460;

        this.handleClick = this.handleClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.card = this.querySelector(
          '.premium-accordion-panel__card'
        );

        this.trigger = this.querySelector(
          '.premium-accordion-panel__trigger'
        );

        this.content = this.querySelector(
          '.premium-accordion-panel__content'
        );

        this.contentInner = this.querySelector(
          '.premium-accordion-panel__content-inner'
        );

        if (
          !this.card ||
          !this.trigger ||
          !this.content ||
          !this.contentInner
        ) {
          return;
        }

        this.isOpen = this.card.classList.contains('is-open');

        if (this.isOpen) {
          this.content.style.height = 'auto';
          this.content.style.visibility = 'visible';
          this.trigger.setAttribute('aria-expanded', 'true');
        } else {
          this.content.style.height = '0px';
          this.content.style.visibility = 'hidden';
          this.trigger.setAttribute('aria-expanded', 'false');
        }

        this.trigger.addEventListener(
          'click',
          this.handleClick
        );

        window.addEventListener(
          'resize',
          this.handleResize
        );
      }

      disconnectedCallback() {
        if (this.trigger) {
          this.trigger.removeEventListener(
            'click',
            this.handleClick
          );
        }

        window.removeEventListener(
          'resize',
          this.handleResize
        );
      }

      handleClick() {
        if (this.isAnimating) {
          return;
        }

        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        if (reduceMotion) {
          this.toggleWithoutAnimation();
          return;
        }

        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.isAnimating = true;
        this.isOpen = true;

        this.card.classList.remove('is-closing');
        this.card.classList.add('is-open');

        this.trigger.setAttribute('aria-expanded', 'true');

        this.content.style.visibility = 'visible';
        this.content.style.height = '0px';

        this.content.getBoundingClientRect();

        const targetHeight = this.contentInner.scrollHeight;

        requestAnimationFrame(() => {
          this.content.style.height = `${targetHeight}px`;
        });

        this.waitForHeightTransition(() => {
          this.content.style.height = 'auto';
          this.isAnimating = false;
        });
      }

      close() {
        this.isAnimating = true;
        this.isOpen = false;

        const currentHeight =
          this.content.getBoundingClientRect().height;

        this.content.style.height = `${currentHeight}px`;

        this.content.getBoundingClientRect();

        this.card.classList.add('is-closing');
        this.card.classList.remove('is-open');

        this.trigger.setAttribute('aria-expanded', 'false');

        requestAnimationFrame(() => {
          this.content.style.height = '0px';
        });

        this.waitForHeightTransition(() => {
          this.content.style.visibility = 'hidden';
          this.card.classList.remove('is-closing');
          this.isAnimating = false;
        });
      }

      toggleWithoutAnimation() {
        this.isOpen = !this.isOpen;

        this.card.classList.toggle(
          'is-open',
          this.isOpen
        );

        this.card.classList.remove('is-closing');

        this.trigger.setAttribute(
          'aria-expanded',
          this.isOpen ? 'true' : 'false'
        );

        if (this.isOpen) {
          this.content.style.visibility = 'visible';
          this.content.style.height = 'auto';
        } else {
          this.content.style.height = '0px';
          this.content.style.visibility = 'hidden';
        }
      }

      waitForHeightTransition(callback) {
        let finished = false;

        const finish = () => {
          if (finished) {
            return;
          }

          finished = true;

          this.content.removeEventListener(
            'transitionend',
            handleTransitionEnd
          );

          callback();
        };

        const handleTransitionEnd = (event) => {
          if (
            event.target === this.content &&
            event.propertyName === 'height'
          ) {
            finish();
          }
        };

        this.content.addEventListener(
          'transitionend',
          handleTransitionEnd
        );

        window.setTimeout(
          finish,
          this.animationDuration + 120
        );
      }

      handleResize() {
        if (
          this.isOpen &&
          this.isAnimating &&
          this.contentInner
        ) {
          this.content.style.height =
            `${this.contentInner.scrollHeight}px`;
        }
      }
    }

    customElements.define(
      'premium-accordion-panel',
      PremiumAccordionPanel
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-accordion-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('premium-accordion-card')) {
    class PremiumAccordionCard extends HTMLElement {
      constructor() {
        super();

        this.details = null;
        this.summary = null;
        this.content = null;

        this.cardAnimation = null;
        this.contentAnimation = null;
        this.isAnimating = false;

        this.animationDuration = 440;
        this.animationEasing = 'cubic-bezier(0.22, 1, 0.36, 1)';

        this.handleSummaryClick =
          this.handleSummaryClick.bind(this);
      }

      connectedCallback() {
        this.details = this.querySelector(
          '.premium-accordion-card__details'
        );

        this.summary = this.querySelector(
          '.premium-accordion-card__summary'
        );

        this.content = this.querySelector(
          '.premium-accordion-card__content'
        );

        if (
          !this.details ||
          !this.summary ||
          !this.content
        ) {
          return;
        }

        this.summary.addEventListener(
          'click',
          this.handleSummaryClick
        );
      }

      disconnectedCallback() {
        if (this.summary) {
          this.summary.removeEventListener(
            'click',
            this.handleSummaryClick
          );
        }

        this.cancelAnimations();
      }

      handleSummaryClick(event) {
        event.preventDefault();

        if (this.isAnimating) {
          return;
        }

        if (
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
        ) {
          this.details.open = !this.details.open;
          return;
        }

        if (this.details.open) {
          this.closeAccordion();
        } else {
          this.openAccordion();
        }
      }

      openAccordion() {
        this.isAnimating = true;
        this.cancelAnimations();

        const startHeight = this.getCurrentHeight();

        this.details.style.height = `${startHeight}px`;
        this.details.style.overflow = 'hidden';
        this.details.classList.add('is-animating');
        this.details.classList.remove('is-closing');

        /*
         * Content measure করার জন্য details open করতে হবে।
         */
        this.details.open = true;

        this.content.style.opacity = '0';
        this.content.style.transform =
          'translateY(-10px)';

        requestAnimationFrame(() => {
          const endHeight = this.getOpenHeight();

          this.cardAnimation = this.details.animate(
            [
              {
                height: `${startHeight}px`
              },
              {
                height: `${endHeight}px`
              }
            ],
            {
              duration: this.animationDuration,
              easing: this.animationEasing,
              fill: 'forwards'
            }
          );

          this.contentAnimation = this.content.animate(
            [
              {
                opacity: 0,
                transform: 'translateY(-10px)'
              },
              {
                opacity: 1,
                transform: 'translateY(0)'
              }
            ],
            {
              duration: 350,
              delay: 65,
              easing: this.animationEasing,
              fill: 'forwards'
            }
          );

          this.cardAnimation.onfinish = () => {
            this.finishAnimation();
          };

          this.cardAnimation.oncancel = () => {
            this.finishAnimation();
          };
        });
      }

      closeAccordion() {
        this.isAnimating = true;
        this.cancelAnimations();

        const startHeight = this.getCurrentHeight();
        const endHeight = this.getClosedHeight();

        this.details.style.height = `${startHeight}px`;
        this.details.style.overflow = 'hidden';

        this.details.classList.add(
          'is-animating',
          'is-closing'
        );

        this.cardAnimation = this.details.animate(
          [
            {
              height: `${startHeight}px`
            },
            {
              height: `${endHeight}px`
            }
          ],
          {
            duration: this.animationDuration,
            easing: this.animationEasing,
            fill: 'forwards'
          }
        );

        this.contentAnimation = this.content.animate(
          [
            {
              opacity: 1,
              transform: 'translateY(0)'
            },
            {
              opacity: 0,
              transform: 'translateY(-10px)'
            }
          ],
          {
            duration: 280,
            easing: 'cubic-bezier(0.4, 0, 1, 1)',
            fill: 'forwards'
          }
        );

        this.cardAnimation.onfinish = () => {
          this.details.open = false;
          this.finishAnimation();
        };

        this.cardAnimation.oncancel = () => {
          this.finishAnimation();
        };
      }

      getCurrentHeight() {
        return this.details.getBoundingClientRect().height;
      }

      getOpenHeight() {
        const computedStyle =
          window.getComputedStyle(this.details);

        const borderTop =
          parseFloat(computedStyle.borderTopWidth) || 0;

        const borderBottom =
          parseFloat(computedStyle.borderBottomWidth) || 0;

        return (
          this.details.scrollHeight +
          borderTop +
          borderBottom
        );
      }

      getClosedHeight() {
        const computedStyle =
          window.getComputedStyle(this.details);

        const borderTop =
          parseFloat(computedStyle.borderTopWidth) || 0;

        const borderBottom =
          parseFloat(computedStyle.borderBottomWidth) || 0;

        return (
          this.summary.getBoundingClientRect().height +
          borderTop +
          borderBottom
        );
      }

      cancelAnimations() {
        if (this.cardAnimation) {
          this.cardAnimation.cancel();
          this.cardAnimation = null;
        }

        if (this.contentAnimation) {
          this.contentAnimation.cancel();
          this.contentAnimation = null;
        }
      }

      finishAnimation() {
        this.details.style.height = '';
        this.details.style.overflow = '';

        this.content.style.opacity = '';
        this.content.style.transform = '';

        this.details.classList.remove(
          'is-animating',
          'is-closing'
        );

        this.cardAnimation = null;
        this.contentAnimation = null;
        this.isAnimating = false;
      }
    }

    customElements.define(
      'premium-accordion-card',
      PremiumAccordionCard
    );
  }
  } catch(e) { console.error(e); }
})();

})();
